var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var MountingHolePadGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    var self = this;
    
    IpcPthPadGeneratorInteractionModel.apply(this, arguments);

    this.padDiameter = this.shadow("padDiameter",
        function() {
            return self.data.padDiameter() / self.getUnitFactor();
        },
        function(value) {
            return self.data.padDiameter(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.padDiameter, self.userSettingsModel.distanceUnit
        ]
    );

    this.holeDiameter = this.shadow("holeDiameter",
        function() {
            return self.data.holeDiameter() / self.getUnitFactor();
        },
        function(value) {
            return self.data.holeDiameter(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.holeDiameter, self.userSettingsModel.distanceUnit
        ]
    );

    this.plated = this.shadow("plated",
        function() {
            return self.data.plated();
        },
        function(value) {
            return self.data.plated(value);
        },
        [
            self.data.plated
        ]
    );

    this.withPad = this.shadow("withPad",
        function() {
            return self.data.withPad();
        },
        function(value) {
            return self.data.withPad(value);
        },
        [
            self.data.withPad
        ]
    );

    this.withVia = this.shadow("withVia",
        function() {
            return self.data.withVia();
        },
        function(value) {
            return self.data.withVia(value);
        },
        [
            self.data.withVia
        ]
    );

    this.viaCount = this.shadow("viaCount",
        function() {
            return self.data.viaCount();
        },
        function(value) {
            // update name list to account the vias as regular pads
            var status = self.data.viaCount(value);
            self.updateNameList();
            return status;
        },
        [
            self.data.viaCount
        ]
    );

    this.viaDiameter = this.shadow("viaDiameter",
        function() {
            return self.data.viaDiameter() / self.getUnitFactor();
        },
        function(value) {
            return self.data.viaDiameter(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.viaDiameter, self.userSettingsModel.distanceUnit
        ]
    );

    this.viaCenterOffset = this.shadow("viaCenterOffset",
        function() {
            return self.data.viaCenterOffset() / self.getUnitFactor();
        },
        function(value) {
            return self.data.viaCenterOffset(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.viaCenterOffset, self.userSettingsModel.distanceUnit
        ]
    );

    this.viaThermalRelief = this.shadow("viaThermalRelief",
        function() {
            return self.data.viaThermalRelief();
        },
        function(value) {
            return self.data.viaThermalRelief(value);
        },
        [
            self.data.viaThermalRelief
        ]
    );

    this.showViaSettings = this.shadow("showViaSettings",
        function() {
            return self.withVia() && self.withPad();
        },
        null,
        [
            self.data.withVia, self.data.withPad
        ]
    );
};

lib_core.inherit(MountingHolePadGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
MountingHolePadGeneratorInteractionModel.$class = 'MountingHolePadGeneratorInteractionModel';

module.exports = MountingHolePadGeneratorInteractionModel;

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForHoleWithPad = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('mountingHolePad', 'Mounting Hole Pad'), this.withPad, this.showFootprintParams)];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForHoleWithPlating = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('plated', 'Plated'), this.plated, (this.showFootprintParams() ? this.withPad : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForViaOption = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('withVias', 'With Vias'), this.withVia, (this.showFootprintParams() ? this.withPad : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForViaCount = function() {
    return [PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('viasCount', 'Vias Count'), this.viaCount, (this.showFootprintParams() ? this.showViaSettings : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForViaDiameter = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b2', this.LCLZ('viaDiameter', 'Via Diameter'), true, null, false, this.viaDiameter, this.userSettingsModel.distanceUnit, false, (this.showFootprintParams() ? this.showViaSettings : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForViaOffset = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E2', this.LCLZ('ViaOffset', 'Via Offset From Hole Center'), true, null, false, this.viaCenterOffset, this.userSettingsModel.distanceUnit, false, (this.showFootprintParams() ? this.showViaSettings : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForViaThermalRelief = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('viaThermalRelief', 'Via Thermal Relief'), this.viaThermalRelief, (this.showFootprintParams() ? this.showViaSettings : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForPadSize = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E1', this.LCLZ('padWidth', 'Pad Width'), true, null, false, this.padDiameter, this.userSettingsModel.distanceUnit, false, (this.showFootprintParams() ? this.withPad : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForHoleSize = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('holeDiameter', 'Hole Diameter'), true, null, false, this.holeDiameter, this.userSettingsModel.distanceUnit, false, this.showFootprintParams)];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForPadShape = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('padShape', 'Pad Shape'), this.padShape, this.padShapeList, (this.showFootprintParams() ? this.withPad : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForPadHoleRatio = function() {
    return [PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('viaPadToHoleRatio', 'Via Pad to Hole Ratio'), this.padToHoleRatio, (this.showFootprintParams() ? this.withVia : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForDensityLevel = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('producibilityLevel', 'Producibility Level'), this.densityLevel, this.componentDensityList, (this.showFootprintParams() ? this.withPad : this.showFootprintParams))];
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElementForMapping = function() {
    return PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('mapSilkscreen', 'Map Silkscreen to Body'), this.silkscreenMappingTypeToBody, this.silkscreenMappingTypeToBodyList, (this.showFootprintParams() ? this.withPad : this.showFootprintParams));
};

MountingHolePadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForHoleWithPad());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadSize());

    imElements = imElements.concat(this.getInspectorElementForHoleWithPlating());
    
    imElements = imElements.concat(this.getInspectorElementForViaOption());
    imElements = imElements.concat(this.getInspectorElementForViaCount());
    imElements = imElements.concat(this.getInspectorElementForViaDiameter());
    imElements = imElements.concat(this.getInspectorElementForViaOffset());
    imElements = imElements.concat(this.getInspectorElementForViaThermalRelief());

    imElements = imElements.concat(this.getInspectorElementForHoleSize());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};